import React from 'react';
import './Footer.css';

const Footer: React.FC = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-content">
          <div className="footer-brand">
            <div className="footer-logo">
              <img 
                src="/assets/logos/siorm-logo-horizontal.svg" 
                alt="SIORM Drones" 
                className="footer-logo-image"
              />
            </div>
          </div>
          
          <div className="footer-links">
            <div className="footer-section">
              <h4>Navegación</h4>
              <ul>
                <li><a href="#gallery">Galería</a></li>
                <li><a href="#services">Servicios</a></li>
                <li><a href="#contact">Contacto</a></li>
                <li><a href="https://www.youtube.com/@SiormDrones" target="_blank" rel="noopener noreferrer">YouTube</a></li>
              </ul>
            </div>
            
            <div className="footer-section">
              <h4>Servicios Destacados</h4>
              <ul>
                <li><a href="#services">Fotografía Aérea</a></li>
                <li><a href="#services">Mapeo y Topografía</a></li>
                <li><a href="#services">Transmisiones en Vivo</a></li>
                <li><a href="#services">Proyectos Personalizados</a></li>
              </ul>
            </div>
          </div>
        </div>
        
        <div className="footer-bottom">
          <p>&copy; {new Date().getFullYear()} SIORM Drones. Todos los derechos reservados. | Tucumán, Argentina</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;